<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{ $t('withdrawal.balance_withdrawal') }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-form v-model="withdrawalValid" @submit.prevent>
        <v-text-field
          prepend-icon="attach_money"
          name="amount"
          ref="withdrawalAmount"
          type="number"
          :rules="[rules.required, rules.withdrawable]"
          :disabled="isCurrentWithdrawalExist && !editMode"
          :label="$t('withdrawal.amount')"
          v-model="withdrawalAmount"
          required
        ></v-text-field>
        <v-flex>{{ `${$t('withdrawal.settlement_date')}: ${this.$store.state.userData.settlement_date}` }}</v-flex>
        <v-flex>
          <span class="hint">* {{ $t('withdrawal.hint') }}</span>
        </v-flex>
        <v-card-actions>
          <v-spacer></v-spacer>
          <template v-if="editMode">
            <v-btn color="error" v-if="!submitLoading" @click="cancelEdit">{{ $t('cancel') }}</v-btn>
            <v-btn
              color="success"
              :loading="submitLoading"
              @click="submitWithdrawalUpdate"
            >{{ $t('confirm') }}</v-btn>
          </template>
          <v-btn
            v-else
            color="primary"
            :loading="submitLoading"
            @click="isCurrentWithdrawalExist ? editWithdrawal() : submitWithdrawal()"
          >{{ isCurrentWithdrawalExist ? $t('withdrawal.update') : $t('submit') }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import withdrawalService from '@/services/withdrawal'

export default {
  data () {
    return {
      submitLoading: false,
      withdrawalAmount: null,
      editMode: false,
      withdrawalValid: true,
      rules: {
        required: value => (value !== '' && value !== null) || this.$t('required'),
        withdrawable: value => {
          return value <= this.$store.state.userData.withdrawable_balance || this.$t('withdrawal.exceed_withdrawable')
        }
      }
    }
  },

  computed: {
    isCurrentWithdrawalExist () {
      return this.$store.state.userData.current_withdrawal !== null
    }
  },

  created () {
    this.reloadWithdrawalAmount()
  },

  methods: {
    reloadWithdrawalAmount () {
      this.withdrawalAmount = this.isCurrentWithdrawalExist ? this.$store.state.userData.current_withdrawal.amount : null
    },

    editWithdrawal () {
      this.editMode = true
      this.$nextTick(() => this.$refs.withdrawalAmount.focus())
    },

    cancelEdit () {
      this.editMode = false
      this.reloadWithdrawalAmount()
    },

    async submitWithdrawal () {
      if (!this.withdrawalValid) {
        return
      }

      this.submitLoading = true
      try {
        let { data } = await withdrawalService.store({ amount: this.withdrawalAmount })
        this.$store.commit('SET_CURRENT_WITHDRAWAL', data.data)
        this.reloadWithdrawalAmount()
        // this.$toasted.success(this.$t('withdrawal.request_success')).goAway(7000)
      } catch (error) {
        // this.$toasted.error(this.$t('error_message')).goAway(5000)
      } finally {
        this.submitLoading = false
      }
    },

    async submitWithdrawalUpdate () {
      if (!this.withdrawalValid) {
        return
      }

      this.submitLoading = true
      try {
        let { data } = await withdrawalService.update(this.$store.state.userData.current_withdrawal.id, { amount: this.withdrawalAmount })
        this.$store.commit('SET_CURRENT_WITHDRAWAL', data.data)
        this.reloadWithdrawalAmount()
        // this.$toasted.success(this.$t('withdrawal.update_request_success')).goAway(7000)
      } catch (error) {
        // this.$toasted.error(this.$t('error_message')).goAway(5000)
      } finally {
        this.editMode = false
        this.submitLoading = false
      }
    }
  }
}
</script>
